import React, { Component } from "react";
import { Player, ControlBar, PosterImage, BigPlayButton, VolumeMenuButton, PlayToggle } from 'video-react'
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ModVideo extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className={'l-block l-block--display-' + block.display} style={{backgroundColor: block.block_color}}>
	        	<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        	<div className="l-grid">
			        	<div className="l-grid__col">
			        		<div className="scope-video">
				        	<Player src={block.video} poster={block.poster} ref={player => { this.player = player; }}>
								<BigPlayButton position="center" />
								<ControlBar autoHide={false} disableDefaultControls={true}>
									<PlayToggle />
									<VolumeMenuButton />
									{block.caption &&
										<p>{ block.caption }</p>
									}
								</ControlBar>
							</Player>
							</div>
			        	</div>
			        </div>
		        </ScrollAnimation>
			</div>
		)
	};

};
